'use strict';

define('lib/helpers/data-attr',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('data-attr', function (opt) {
    if (opt.hash.ignoreEmpty && !opt.hash.value) {
      return '';
    }

    var value = opt.hash.value;
    if (typeof value == 'object') {
      value = JSON.stringify(value);
    }

    return new Handlebars.SafeString(
      'data-' + opt.hash.key + '="' + Handlebars.Utils.escapeExpression(value) + '"'
    );
  });
});

